import { useSyncExternalStore } from "react";

import {
  getExperienceLevel,
  subscribeExperience,
  type ExperienceLevel,
} from "./experienceLevel";

/**
 * Nivel de experiencia, reactivo.
 *
 * En SSR devuelve `full` a propósito: el HTML servido es el de la experiencia completa y
 * el atributo `data-experience` lo escribe el script inline de `root.tsx` antes del
 * primer pintado. `useSyncExternalStore` con `getServerSnapshot` es justamente el
 * mecanismo soportado para esto — hidrata con el valor del servidor y re-renderiza
 * después, sin mismatch.
 *
 * OJO: lo que apaga las animaciones DECORATIVAS es el CSS (`html[data-experience=
 * "reduced"]`), que no necesita este hook y funciona desde antes del primer pintado. Este
 * hook es para lo que sólo se puede decidir en JS: no montar un `<video>`, no arrancar un
 * `setInterval`, no registrar un listener.
 */
export function useExperienceLevel(): ExperienceLevel {
  return useSyncExternalStore(subscribeExperience, getExperienceLevel, () => "full" as const);
}

/** Azúcar para el caso más común. */
export function useReducedExperience(): boolean {
  return useExperienceLevel() === "reduced";
}
